// "Stats for nerds" data (F-CALL-6): pull-based — the UI polls only while the
// panel is open, so closed panels cost nothing (§9.3 discipline).

export interface AttendeeStats {
  identity: string;
  videoBitrate: number; // bits/s
  audioBitrate: number;
  width: number;
  height: number;
}

export function formatBitrate(bps: number): string {
  if (bps <= 0) return '—';
  if (bps >= 1_000_000) return `${(bps / 1_000_000).toFixed(1)} Mbps`;
  return `${Math.round(bps / 1000)} kbps`;
}
